import { TableCell, TableRow } from "@mui/material";
import { EntityId } from "@reduxjs/toolkit";
import React from "react";
import { FaRegChartBar } from "react-icons/fa";
import { ExperienceCard } from "../../types/types";
import { StudentButton } from "../expereince.list.presentation/experienceListPresentation.styles";
import { images } from "../../../../constants";
import { MdModeEdit } from "react-icons/md";
import { AuthAdmin } from "../../../auth/types/auth.types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
type ExperiencePrerequisiteListPresentationProp = {
  item: ExperienceCard;
  onEdit: (id: EntityId) => void;
  onReview: (id: EntityId) => void;
  admin: AuthAdmin | null
  permissionResult:any
};
const ExperiencePrerequisiteListPresentation: React.FC<
ExperiencePrerequisiteListPresentationProp
> = ({ item, onEdit, onReview , admin, permissionResult }) => {
const {
  attributes,
  listeners,
  setNodeRef,
  transform,
  transition,
  setActivatorNodeRef
} = useSortable({id:item._id})
  return (
    <TableRow style={{
      transform:CSS.Transform.toString(transform),
      transition,
      borderRadius: 10,
      outline: "1px solid #AEAEAE",
      marginBottom:10,
      marginTop:20,
      position:'relative',
      userSelect:'none' as const
      
    }} ref={setNodeRef}>
              <TableCell style={{
                maxWidth: 10,
                padding: '8px 16px',
                fontFamily: 'Poppins',
                position:'absolute',
                left:-52,
                top:11,
                border:'none'
              }}>
              
              </TableCell>
      

       <TableCell style={{
        maxWidth: 10,
        padding: '8px 16px',
        fontFamily: 'Poppins'
      }} ref={setActivatorNodeRef} {...attributes} {...listeners}>
      
          <button
            onClick={() => {
            }}
            style={{
              background: 'none',
              border: 'none',
              fontSize: 'x-large',
              paddingLeft: 2,
              color: '#2f8f6c'
            }}
          >
              <img style={{width:10}} src={images.ExpDrag} alt="Experience"></img>
          </button>
        
      </TableCell>
      <TableCell style={{
           padding: '10px 16px 4px',
        }}>
        <img
         style={{
          width: 40,
          height: 40,
          borderRadius: 50,
          border: "1px solid #CBCBCB"
        }}
          src={item.image}
          alt=""
        />{' '}
      </TableCell>
      <TableCell
      style={{
        maxWidth: 130,
        padding: '8px 16px',
        textAlign: 'center',
        fontSize: 12,
        justifyContent: 'center',
        fontFamily: 'Poppins'
      }}
      >{item.title}</TableCell>
      <TableCell 
      style={{
        maxWidth: 285,
        textAlign: 'left',
        padding: '13px 16px',
        fontSize: 12,
        justifyContent: 'center',
        fontFamily: 'Poppins',
        WebkitLineClamp:2,
        WebkitBoxOrient:'vertical',
        overflow:'hidden',
        paddingBottom:0,
        border:'none',
        display:'-webkit-inline-box',
        height:'50px',
        alignContent:'center'
      }}
      >{item.description}</TableCell>
      <TableCell style={{
          maxWidth: 130,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}>
        <div style={{
            border: '1px solid #CED4DA',
            borderRadius: 5,
            width: 100,
            fontSize: 14,
            marginLeft: 7,
            marginBottom: 2
          }}>{new Date(item.startDate).toLocaleDateString()}</div>
        <div style={{
            border: '1px solid #CED4DA',
            borderRadius: 5,
            width: 100,
            fontSize: 14,
            marginLeft: 7

          }}>{new Date(item.endDate).toLocaleDateString()}</div>
      </TableCell>
      <TableCell style={{
          maxWidth: 130,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}> - </TableCell>
      <TableCell style={{
          maxWidth: 130,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}>{item.xpCompletion}</TableCell>
      <TableCell style={{
          maxWidth: 130,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}>{item.experienceType.title}</TableCell>
      <TableCell 
      style={{
        maxWidth: 100,
        padding: '8px 16px',
        textAlign: 'center',
        fontSize: 12,
        justifyContent: 'center',
        fontFamily: 'Poppins'
      }}
        >{item.completionType.title}</TableCell>
      <TableCell style={{overflow: 'visible' ,  padding: '8px 16px' }}>
        <div style={{ display: 'flex' }}>
            <StudentButton
              style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: 12,
                marginLeft: 2,
                padding: 8
              }}
              onClick={() => {
                onEdit(item._id)
              }}
              spaceLeft={''}
              disabled={
                admin?.adminLevel === 'ADMIN' && !permissionResult?.experience
              }
            >
              <span
                className="experience-item-button"
                style={{
                  maxWidth: 130,
                  textAlign: 'center',
                  fontSize: 10,
                  justifyContent: 'center',
                  fontFamily: 'Poppins',
                  fontWeight: 400,
                  paddingRight: 8
                }}
              >
                Edit
              </span>
              <MdModeEdit color="#34c38f" size="20" style={{ backgroundColor: '#fff', borderRadius: 50, padding: 3 }} />
            </StudentButton>
          <StudentButton
            style={{        display: 'flex',
              alignItems: 'center',
              marginRight: 12,
              marginLeft: 2,
              padding: 8}}
            onClick={() => {
              onReview(item._id)
            }}
            spaceLeft={''}
          >
            <span
              className="experience-item-button"
              style={{ paddingRight: 5 }}
            >
              Review
            </span>
            <FaRegChartBar />
          </StudentButton>
        </div>
      </TableCell>
    </TableRow>
  )
}

export default ExperiencePrerequisiteListPresentation
